import { createRouter, createWebHashHistory } from 'vue-router'
const vrouter =  createRouter({
    history: createWebHashHistory(),
    routes: [
        {
            name:"主路由",
            path: '/',
            redirect: "/login",
        },
        {
            path: "/page",
            name: "page",
            component: () => import("@/view/page.vue"),
			children:[
				{
					path:"/home",
					name: "首页",
                    component: () => import("@/view/home/home.vue"),
                    desc:"home"
				},{
					path:"/questions",
					name: "问卷",
                    component: () => import("@/view/users/student/view/questions/questions.vue"),
                    desc:"student"
				},{
                    path:"/topic/:id",
                    name:"topic",
                    component: () => import("@/view/users/student/view/questions/topic/topic.vue"),
                    desc:"student-topic"
                },{
                    path:"/manage/ques",
                    name:"问卷管理",
                    component:() => import("@/view/users/admin/view/quesmanage/quesmanage.vue"),
                    desc:"admin"
                },{
                    path:"/show/ques/:id",
                    name:"问卷查看",
                    component:() => import("@/view/users/admin/view/quesmanage/children/topic.vue"),
                    desc:"admin-ques-topic"
                },{
                    path:"/manage/user",
                    name:"用户管理",
                    desc:"admin",
                    children:[
                        {
                            path:"/usermanage/student",
                            name:"学生管理",
                            component:() => import("@/view/users/admin/view/usermanage/student/student.vue")
                        },{
                            path:"/usermanage/teacher",
                            name:"教师管理",
                            component:() => import("@/view/users/admin/view/usermanage/teacher/teacher.vue")
                        },{
                            path:"/usermanage/comprehensive",
                            name:"综合管理",
                            component:() => import("@/view/users/admin/view/usermanage/index.vue")
                        }
                    ]
                },{
                    path:"/manage/user/info/:uid",
                    name:"用户信息查看",
                    desc:"admin-manage-user-info",
                    component:() => import("@/view/users/admin/view/usermanage/userinfoshow/index.vue")
                },{
                    path:"/score/answer",
                    name:"问卷评分",
                    desc:"teacher",
                    component:() => import("@/view/users/teacher/view/answer/index.vue")
    
                },{
                    path:"/score/answer/students/:pid",
                    name:"问卷评分-选择学生",
                    desc:"teacher-student-choice",
                    component:() => import("@/view/users/teacher/view/answer/student/index.vue")
    
                },
                {
                    path:"/student/answer/view/:pid",
                    name:"学生查看问卷回答视图",
                    desc:"student-answer-view",
                    component:() => import("@/view/users/student/view/questions/answer/answer.vue")
                },
                {
                    path:"/userInfo",
                    name:"个人信息",
                    component:() => import("@/view/users/userInfo.vue"),
                    desc:"user"
                },
                {
                    path:"/testv",
                    name:"测试",
                    component:() => import("@/view/testV/testv.vue"),
                    desc:"cs"
                }
			]
        },
        {
            path: "/login",
            name: "login",
            component: () => import("@/view/login/login.vue"),
        }
    ]
});
export default vrouter;